import React, { useState, useEffect } from "react";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  ContentSideBySideCustomInv,
  Hero,
  Gallery,
  SpacerV,
  Stats,
} from "../components/Hero";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TextField from "@mui/material/TextField";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { API_URL } from "../actions/auth";
import { alertMessage } from "../actions/auth";
import Lottie from "react-lottie";
import {
  Collage,
  Features,
  OurProcess,
  Tailor,
  YouWillGet,
  Trust,
} from "../components/Sections";

export default function ContactUs() {
  useEffect(() => {}, []);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [description, setDescription] = useState("");
  const [company, setCompany] = useState("");
  const [website, setWebsite] = useState("");
  const [budget, setBudget] = useState("");

  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  function onSubmit(e) {
    e.preventDefault();
    var body = {};
    body["name"] = name;
    body["email"] = email;
    body["phone_number"] = phoneNumber;
    body["description"] = description;
    body["company"] = company;
    body["website"] = website;
    body["budget"] = budget;

    axios
      .post(API_URL + "add_quote", JSON.stringify(body))
      .then((res) => {
        setName("");
        setEmail("");
        setPhoneNumber("");
        setDescription("");
        setCompany("");
        setWebsite("");
        setBudget("");

        dispatch(
          alertMessage(
            "SUCCESS",
            "SUCCESS",
            "Your request has been submitted. Our team will get back to you."
          )
        );
      })
      .catch((err) => {});
  }

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div style={{ marginTop: "6vh" }} />
        <div style={{ padding: "100px", backgroundColor: "#111" }}>
          <Grid container spacing={15}>
            <Grid
              item
              md={7}
              xs={12}
              sm={12}
              style={{
                maxWidth: state.auth.isMobile ? "80vw" : "100vw",
                height: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                minHeight: "50vh",
              }}
            >
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "center",
                  marginBottom: "25px",
                  fontWeight: 600,
                  marginTop: "15px",
                }}
              >
                Let’s Build Something Extraordinary Together
              </div>

              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "40px",
                  color: "white",
                  zIndex: 999,
                  textAlign: state.auth.isMobile ? "center" : "left",
                }}
              >
                Why Connect With Us?
              </div>
              <div
                style={{
                  display:
                    state.auth.isMobile || state.auth.view == "TABP"
                      ? "none"
                      : "block",
                }}
              >
                <Tailor
                  invert
                  title1="Custom Solutions For You"
                  subtitle1="Customized solutions designed for your sector."
                  title2="Expertise You Can Trust"
                  subtitle2="Strategies crafted to achieve measurable outcomes."
                  title3="Seamless Collaboration"
                  subtitle3="Intuitive tools for seamless integration and management."
                />
              </div>
            </Grid>
            <Grid
              item
              md={5}
              xs={12}
              sm={12}
              style={{
                maxWidth: state.auth.isMobile ? "80vw" : "100%",
                height: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                minHeight: "50vh",
                marginTop: "25px",
              }}
            >
              <form
                className="anigrad"
                style={{
                  width: state.auth.isMobile ? "80vw" : "110%",
                  backdropFilter: "blur(5px)",
                  padding: "25px",
                  borderRadius: "5px",
                  backgroundColor: "#ffd400",
                }}
                onSubmit={onSubmit}
              >
                <div
                  style={{
                    width: state.auth.isMobile ? "80vw" : "100",
                    fontSize: state.auth.isMobile ? "30px" : "30px",
                    fontWeight: "600",
                    lineHeight: "55px",
                    color: "white",
                    textAlign: "center",
                    zIndex: 999,
                  }}
                >
                  Get Your Free Quote
                </div>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    sm={12}
                    style={{
                      width: "100h%",
                      height: "100%",
                    }}
                  >
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: 600,
                            opacity: 1,
                          },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="name"
                      autoComplete="name"
                      autoFocus
                      placeholder="Full Name *"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: { navColor: "#444", navOpacity: 1 },
                        });
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    sm={12}
                    style={{
                      width: "100h%",
                      height: "100%",
                    }}
                  >
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: 600,
                            opacity: 1,
                          },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="email"
                      autoComplete="email"
                      autoFocus
                      placeholder="E-mail *"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: { navColor: "#444", navOpacity: 1 },
                        });
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    sm={12}
                    style={{
                      width: "100h%",
                      height: "100%",
                    }}
                  >
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: 600,
                            opacity: 1,
                          },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="website"
                      autoComplete="website"
                      autoFocus
                      placeholder="Website*"
                      value={website}
                      onChange={(e) => {
                        setWebsite(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: { navColor: "#444", navOpacity: 1 },
                        });
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    sm={12}
                    style={{
                      width: "100h%",
                      height: "100%",
                    }}
                  >
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: 600,
                            opacity: 1,
                          },
                      }}
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="company"
                      autoComplete="company"
                      autoFocus
                      placeholder="Company *"
                      value={company}
                      onChange={(e) => {
                        setCompany(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: { navColor: "#444", navOpacity: 1 },
                        });
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    sm={12}
                    style={{
                      width: "100h%",
                      height: "100%",
                    }}
                  >
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: 600,
                            opacity: 1,
                          },
                      }}
                      type="number"
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="phonenumber"
                      autoComplete="phonenumber"
                      autoFocus
                      placeholder="Phone number *"
                      value={phoneNumber}
                      onChange={(e) => {
                        setPhoneNumber(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: { navColor: "#444", navOpacity: 1 },
                        });
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    sm={12}
                    style={{
                      width: "100h%",
                      height: "100%",
                    }}
                  >
                    <TextField
                      sx={{
                        backgroundColor:
                          state.auth.theme == "dark"
                            ? themeStyleDark.backgroundColor
                            : themeStyle.backgroundColor,
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.textColor
                            : themeStyle.textColor,
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                          {
                            color: themeStyle.primaryColor,
                            fontWeight: 600,
                            opacity: 1,
                          },
                      }}
                      type="number"
                      variant="outlined"
                      required
                      fullWidth
                      margin="normal"
                      name="budget"
                      autoComplete="budget"
                      autoFocus
                      placeholder="Budget *"
                      value={budget}
                      onChange={(e) => {
                        setBudget(e.target.value);
                        dispatch({
                          type: "NAV_COLOR",
                          payload: { navColor: "#444", navOpacity: 1 },
                        });
                      }}
                    />
                  </Grid>
                </Grid>
                <TextField
                  sx={{
                    backgroundColor:
                      state.auth.theme == "dark"
                        ? themeStyleDark.backgroundColor
                        : themeStyle.backgroundColor,
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.textColor
                        : themeStyle.textColor,
                    borderRadius: "6px",
                    height: "400",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "& .MuiInputBase-root.MuiOutlinedInput-root ::placeholder":
                      {
                        color: themeStyle.primaryColor,
                        fontWeight: 600,
                        opacity: 1,
                      },
                  }}
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  name="description"
                  autoComplete="description"
                  multiline
                  rows={4}
                  autoFocus
                  placeholder="Notes and Comments *"
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    dispatch({
                      type: "NAV_COLOR",
                      payload: { navColor: "#444", navOpacity: 1 },
                    });
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "2.2vh",
                  }}
                >
                  <Button
                    style={{
                      width: "100%",
                      height: "6vh",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryButtonColor
                          : themeStyle.primaryButtonColor,
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryButtonTextColor
                          : themeStyle.primaryButtonTextColor,
                    }}
                    type="submit"
                    variant="contained"
                  >
                    <span
                      style={{
                        fontSize: state.auth.isMobile ? "1.8vh" : "2.2vh",
                        fontWeight: 600,
                      }}
                    >
                      SUBMIT REQUEST
                    </span>
                  </Button>
                </div>
              </form>
            </Grid>
          </Grid>
        </div>
        <div style={{ display: state.auth.isMobile ? "none" : "block" }}>
          <Trust invert />
        </div>
        <OurProcess
          invert
          step1={"Reach Out to Understand Your Needs"}
          step1description={
            "We begin by listening to you. Share your goals, questions, or challenges, and our team will guide you to the right solutions. Whether you're looking for development support, design services, or strategic consulting, we're here to help."
          }
          step2={"Collaborate to Find Tailored Solutions"}
          step2description={
            "Our experts will work closely with you to identify the best approaches and craft innovative solutions tailored to your unique needs. We value open communication and collaborative problem-solving to ensure the best outcomes."
          }
          step3={"Stay Informed with Transparent Communication"}
          step3description={
            "We believe in keeping you in the loop. From the initial inquiry to project updates and beyond, our team ensures transparent and timely communication so that you always know where things stand."
          }
          step4={"Build Long-Term Relationships with Dedicated Support"}
          step4description={
            "Our commitment doesn't end after the initial interaction. We strive to build long-term relationships by providing ongoing support and ensuring your satisfaction at every step. Connect with us and experience a partnership that grows with your success."
          }
        />

        <YouWillGet
          title1={"Personalized Assistance"}
          title2={"Quick Responses"}
          title3={"Expert Guidance"}
          title4={"Ongoing Support"}
          title5={"Seamless Communication"}
        />
        <div style={{ display: state.auth.isMobile ? "none" : "block" }}></div>
        <Stats />
        <div style={{ height: "100px" }} />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
